import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import isPropValid from '@emotion/is-prop-valid';
import * as BaseComponents from './components';
import { StyledContainer, StyledContent, StyledHeader } from './style';

function Card({
  children,
  className,
  components = {},
  contentProps = {},
  disableGutters = false,
  dividers = true,
  headerContent,
  headerProps = {},
  margin = 'normal',
  spacing = 3,
  title,
  ...rest
}) {
  const { Container, Content, Header } = useMemo(() => ({ ...BaseComponents, ...components }), [
    components
  ]);

  const safeRest = Object.fromEntries(Object.entries(rest).filter(([key]) => isPropValid(key)));

  return (
    <StyledContainer
      $disableGutters={disableGutters}
      as={Container}
      className={className}
      $margin={margin}
      spacing={spacing}
      {...safeRest}
    >
      {title && (
        <StyledHeader as={Header} spacing={spacing} title={title} {...headerProps}>
          {headerContent}
        </StyledHeader>
      )}
      <StyledContent $dividers={dividers} as={Content} spacing={spacing} {...contentProps}>
        {children}
      </StyledContent>
    </StyledContainer>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  components: PropTypes.object,
  contentProps: PropTypes.object,
  disableGutters: PropTypes.bool,
  dividers: PropTypes.bool,
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  headerContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  headerProps: PropTypes.object,
  spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string
};

export default Card;
